<template>
  <div class="banner" :style="{'background-image':'url('+banner.img+')'}">
    <h2 v-html="banner.title"></h2>
    <p v-if="banner.p">{{banner.p}}</p>
    <div v-html="banner.text"></div>
  </div>
</template>
<script>
export default {
  name:'banner',
  props:{
    banner:{
      type:Object,
      default:{}
    }
  },
  components:{},
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
  .banner{
    background-repeat: no-repeat;
    background-position:center top;
    height:756px;
    background-size: contain;
    text-align: center;
    color:#fff;
    h2{
      padding-top:110px;
      font-size:54px;
      font-weight: bold;
    }
    p{
      font-size:50px;
    }
    div{
      margin-top:20px;
      font-size:28px;
      line-height:40px;
    }
  }
</style>
<style lang="scss">
   .banner h2{
     span{
       color:#f8e466;
     }
   }
</style>
